import { ListParams, NewListParams, ResponseStatus } from "models/common";
import { DetailUserSkip } from "models/managerLesson";
import {
  DetailTestByUser,
  ExamNoQuestion,
  ListExam,
  ListExamNoQuestionResponse,
  ListExamResponse,
  ListQuestionByExamIdResponse,
  ListResponseExam,
  ListTest,
  ListTestByCodeExamResponse,
  QuestionByExamId,
  ResponseListSkipExam,
  ResponseSubmissionExam,
} from "models/managerTest";
import axiosClient from "./axiosClient";

const managerTestApi = {
  createExam(value: any): Promise<ResponseStatus> {
    const url = "/create-exam";
    return axiosClient.post(url, value);
  },

  updateExam(value: any, examId: string | undefined): Promise<ResponseStatus> {
    const url = `/exam/${examId}`;
    return axiosClient.put(url, value);
  },

  updateExamV2(value: any, examId: string | number | undefined): Promise<ResponseStatus> {
    const url = `/v2/exam/${examId}`;
    return axiosClient.put(url, value);
  },

  getUsersByExamID(examId: string) {
    const url = `/exam/${examId}/users`;
    return axiosClient.get(url);
  },

  addUserToExam(value: any) {
    const url = "/exam-users";
    return axiosClient.post(url, value);
  },


  deleteUserFromExam(value: any) {
    const url = "/exam-users";
    return axiosClient.delete(url, {
      data: value,
    });
  },

  submitTest(value: any): Promise<ResponseSubmissionExam> {
    const url = "/exam-submit";
    return axiosClient.post(url, value);
  },

  logViolation(value: { examId: number | string; violationCount: number; violationType?: string }) {
    const url = "/exam/log-violation";
    return axiosClient.post(url, value);
  },

  getExamViolations(examId: number | string) {
    const url = `/exam/monitoring/${examId}/violations`;
    return axiosClient.get(url);
  },

  getListExam(params: ListParams): Promise<ListExamResponse<ListExam>> {
    const url = "/exams";
    return axiosClient.get(url, { params });
  },
  getListExamNoQuestions(params: ListParams): Promise<ListExamNoQuestionResponse<ExamNoQuestion>> {
    const url = "exams-no-questions";
    return axiosClient.get(url, { params });
  },

  getListTestOld(params: ListParams): Promise<ListTestByCodeExamResponse<ListTest>> {
    const url = `/submissions`;
    return axiosClient.get(url, { params });
  },
  getListTest(
    id: number | undefined,
    params: ListParams
  ): Promise<ListTestByCodeExamResponse<ListTest>> {
    const url = `/submissions/${id}`;
    return axiosClient.get(url, { params });
  },

  getAllCandidatesByExamId(
    id: number | undefined,
    params: ListParams
  ): Promise<ListTestByCodeExamResponse<ListTest>> {
    const url = `/exam-all-candidates/${id}`;
    return (axiosClient.get(url, { params }) as Promise<ListTestByCodeExamResponse<ListTest>>).catch((err: any) => {
      if (err?.response?.status === 404) {
        return axiosClient.get(`/submissions/${id}`, { params }) as Promise<ListTestByCodeExamResponse<ListTest>>;
      }
      throw err;
    });
  },

  getDetailExam(id: number, isShuffle?: boolean): Promise<ListExam> {
    const url = `/exam/${id}?isShuffleQNA=${isShuffle || false}`;
    return axiosClient.get(url);
  },

  getExamResultsOverview(id: number): Promise<any> {
    const url = `/exam/results-overview/${id}`;
    return axiosClient.get(url);
  },

  getBatchExamDetails(ids: string, isShuffle?: boolean): Promise<{ responseCode: number; exams: ListExam[] }> {
    const url = `/exams/details?ids=${ids}&isShuffleQNA=${isShuffle || false}`;
    return axiosClient.get(url);
  },

  getDetailExamHasAnswers(id: number): Promise<ListExam> {
    const url = `/questions/${id}`;
    return axiosClient.get(url);
  },

  getDetailTestByUser(id: string | undefined): Promise<DetailTestByUser> {
    const url = `submission-details/${id}`;
    return axiosClient.get(url);
  },

  getQuestionByMutipleExamId(
    examId: string | undefined
  ): Promise<ListQuestionByExamIdResponse<QuestionByExamId>> {
    const url = `questions?examIds=${examId}`;
    return axiosClient.get(url);
  },

  getListSkipExam(params: NewListParams): Promise<ResponseListSkipExam<DetailUserSkip>> {
    const url = "/statistic/statisticDropExam";
    return axiosClient.get(url, { params });
  },
  deleteExam(exam_id: number): Promise<ListResponseExam<ListExam>> {
    const url = `/deleteExam`;
    return axiosClient.post(url, { exam_id });
  },

  updateExamScore(data: any): Promise<ResponseStatus> {
    const url = "/updateExamScore";
    return axiosClient.post(url, data);
  },
};

export default managerTestApi;
